// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Sn9J","inner":"Footer_inner__30VTi"};